import React from "react";
export default class Step4 extends React.Component {
    render() {
        const data = [
            {
                id: "auto",
                text: "Auto-populate"
            },
            {
                id: "manual",
                text: "Manually select"
            }
        ];
        const { handleChange } = this.props;
        //@ts-ignore: This is passed through
        const { nextStep, lastStep } = this.props;
        return (React.createElement("div", { className: "card card-body selection-card" },
            React.createElement("p", null, "Please select how you would like your meals to be selected."),
            React.createElement("p", null, "We can automatically build a menu to your preferences which you can further adjust, or you can create it from scratch"),
            React.createElement("div", { className: "row" }, data.map(d => (React.createElement("div", { className: "col-md", key: d.id },
                React.createElement("div", { className: "form-check custom-check" },
                    React.createElement("input", { className: "form-check-input", type: "radio", name: "mode", value: d.id, id: d.id, onChange: (e) => handleChange(e, "mode", d.id == "auto" ? nextStep : lastStep) }),
                    React.createElement("label", { className: "form-check-label", htmlFor: d.id },
                        React.createElement("span", { className: "custom-check-text" }, d.text)))))))));
    }
}
